/* eslint-disable */

import React, { useEffect, useRef } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useRoutes,
} from "react-router-dom";
import { XCircle } from "react-feather";
import { useMap } from "context/mapContext";
import {
  useResponsive,
  handleChangeContentLayout,
} from "context/responsiveContext";
import useRoles from "customHooks/useRoles";
import Header from "components/Header";
import Sidebar from "components/Sidebar";
import MainMap from "components/MainMap";
import Caret from "components/svgs/Caret";
import ParcelsSearch from "./Tools/ParcelsSearch";
import MyRequests from "./Tools/MyRequests";
import Schemes from "./Tools/Reports/Schemes";
import Requests from "./Tools/Requests";
import Employees from "./Tools/Users/Employees";
import People from "./Tools/Users/People";
import ChangeZone from "./ChangeZone";
import UsersLog from "./Tools/Reports/UsersLog/Index";
import PaymentsLog from "./Tools/Reports/PaymentsLog/Index";
import DashboardReport from "./Tools/Reports/DashboardReport";
import DashboardExternal from "./Tools/Reports/DashboardExternal/DashboardExternal";
import LockedAndUnlockedLand from "./Tools/LockedLand";

function Home() {
  const location = useLocation();
  const [map, mapDispatch] = useMap();
  const pagesWithMap = useRef([
    "/",
    "/myrequests",
    "/requests",
    "/changezone",
    "/search",
  ]);
  const [responsiveState, responsiveDispatch] = useResponsive();
  const { roles } = useRoles();

  useEffect(() => {
    // todo make sure the map does  not reload in wrong time
    // if the user isn't in a page with a map
    // the map container will not be there
    // so I added a flag that will tell the map when to load
    if (pagesWithMap.current.includes(location.pathname) && map.initContext) {
      mapDispatch({ type: "INIT", payload: { initContext: false } });
    }
    if (!pagesWithMap.current.includes(location.pathname) && !map.initContext) {
      mapDispatch({ type: "INIT", payload: { initContext: true } });
    }
  }, [location.pathname, map.initContext]);

  return (
    <div className="flex_fullscreen">
      <Header />
      <main className="home tool flex_fullscreen__item">
        <div
          className={`tool__grid ${
            location.pathname.match(/reports|users/) ? "no-map" : ""
          }`}
        >
          <Sidebar />
          <div className={`content ${responsiveState.contentClass}`}>
            <div className="content__actions">
              <button
                type="button"
                className="content__actions__toggle"
                style={{ display: "block" }}
                onClick={handleChangeContentLayout.bind(
                  this,
                  responsiveDispatch,
                  {
                    close: false,
                    contentClass: responsiveState.contentClass,
                  }
                )}
              >
                <Caret />
              </button>
              <button
                type="button"
                className="content__actions__close"
                onClick={handleChangeContentLayout.bind(
                  this,
                  responsiveDispatch,
                  {
                    close: true,
                    contentClass: responsiveState.contentClass,
                  }
                )}
              >
                <XCircle />
              </button>
            </div>
            <div className="content__container">
              <Routes>
                <Route
                  path="/"
                  element={roles.people ? <MyRequests /> : <ParcelsSearch />}
                />
                <Route path="/search" element={<ParcelsSearch />} />
                <Route path="/myrequests" element={<MyRequests />} />
                <Route path="/dashboard/1" element={<DashboardExternal />} />
                <Route path="/dashboard/2" element={<DashboardExternal />} />
                <Route path="/requests" element={<Requests />} />

                <Route path="/changezone" element={<ChangeZone />} />

                <Route
                  path="/reports/1"
                  element={
                    <>
                      <h2 className="content__title title mt-3">
                        عمليات اصدار المخططات
                      </h2>
                      <Schemes />
                    </>
                  }
                />
                <Route
                  path="/reports/2"
                  element={
                    <>
                      <h2 className="content__title title mt-3">
                        متابعة حركات المستخدمين
                      </h2>
                      <UsersLog />
                    </>
                  }
                />
                <Route path="/reports/3" element={<PaymentsLog />} />
                <Route path="/reports/4" element={<DashboardReport />} />

                <Route path="/users/employees" element={<Employees />} />
                <Route path="/users/people" element={<People />} />

                <Route path="/reports/5" element={<LockedAndUnlockedLand />} />

                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </div>
          </div>
          {useRoutes([
            { path: "/", element: <MainMap /> },
            { path: "/myrequests", element: <MainMap /> },
            { path: "/ChangeZone", element: <MainMap /> },
            { path: "/requests", element: <MainMap /> },
            { path: "/search", element: <MainMap /> },
          ])}
        </div>
      </main>
    </div>
  );
}

export default Home;
